module.exports = __webpack_public_path__ + "img/12.4ca3ea54.png";